import { jsx } from "react/jsx-runtime";
import { Component, Field } from "@contember/binding";
const HiddenField = Component(
  () => null,
  (props) => /* @__PURE__ */ jsx(
    Field,
    {
      defaultValue: props.defaultValue,
      field: props.field,
      isNonbearing: props.isNonbearing ?? true
    }
  ),
  "HiddenField"
);
export {
  HiddenField
};
//# sourceMappingURL=HiddenField.js.map
